import React, { useEffect, useState } from 'react';
import { filter } from 'lodash';

import { DropdownMediumWidth } from 'src/presentation/components/forms/Dropdown';
import { getPublishedIvrs } from 'src/presentation/components/pages/shared/helpers/ivrsHelper';
import { getSelectorOptions } from 'src/presentation/components/pages/shared/utils/Utils';
import Ivr from 'src/models/Ivrs/Ivr';
import { IVR_TAGS } from 'src/models/Thread/Thread';
import ivrsResource from 'src/actions/ivrs/ivrsResource';
import useResource, { STATUS_SUCCEEDED } from 'src/presentation/hooks/useResource';

type IvrDropdownProps = {
  attr: string;
  placeholder?: string;
  description?: string;
};

const IvrDropdown = ({ attr, placeholder, description }: IvrDropdownProps) => {
  const { values: ivrs = [], loadingState: ivrsLoadingState } = useResource(ivrsResource);

  const [ivrOptions, setIvrOptions] = useState<any>();

  useEffect(() => {
    const ivrsLatestVersions = getPublishedIvrs(
      filter(ivrs, (ivr: Ivr) => !ivr.tags || !ivr.tags.length || ivr.tags.includes(IVR_TAGS.TELEPHONY))
    );

    setIvrOptions(
      ivrsLatestVersions.map((ivr: any) => ({
        id: ivr.id,
        label: ivr.name || ivr.description || ivr.id,
        value: ivr.id,
      }))
    );
  }, [ivrs, setIvrOptions]);

  return (
    <DropdownMediumWidth
      data-aid="campaigns-ivr-dropdown"
      disabled={ivrsLoadingState !== STATUS_SUCCEEDED}
      attr={attr}
      options={getSelectorOptions(ivrOptions)}
      label="IVR"
      placeholder={placeholder}
      description={description}
    />
  );
};

export default IvrDropdown;
